import {Suspense} from 'react'
import {ContentContainer, LoadingComponent} from '@components/lib'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import NonAuthNavigation from 'components/NonAuthNavigation'
import Footer from 'components/Footer'

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${({theme}) => theme.colors.bgBody};
`

export const Container = styled(ContentContainer)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const NonAuthLayout = ({children}) => (
  <Wrapper>
    <NonAuthNavigation />
    <Container>
      <Suspense fallback={<LoadingComponent isAbsolute />}>{children}</Suspense>
    </Container>
    <Footer />
  </Wrapper>
)

NonAuthLayout.propTypes = {
  children: PropTypes.node,
}

export default NonAuthLayout
